import {Component, Inject, OnDestroy, ViewEncapsulation} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {locale as polish} from './i18n/pl';
import {FuseTranslationLoaderService} from "../../../../@fuse/services/translation-loader.service";
import {TranslateService} from "@ngx-translate/core";
import {ReservationData} from "../../models/reservationData";
import {Observable, of, Subject} from "rxjs";
import {User} from "../../models";
import {Items} from "../../models/items";
import {catchError, debounceTime, map, startWith, switchMap, takeUntil} from "rxjs/operators";
import {UserService} from "../../services";


@Component({
    selector: 'add-participant-dialog',
    templateUrl: './addParticipantDialog.component.html',
    styleUrls: ['./addParticipantDialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class AddParticipantDialogComponent implements OnDestroy {
    action: string;
    event: ReservationData;
    dialogTitle: string;
    showSeconds = false;
    dialogRef: any;
    editMode: boolean = false;
    eventForm: FormGroup;
    filteredOptions: Observable<User[]>;
    customers: User[];
    form: FormGroup;

    private _unsubscribeAll: Subject<any>;

    /**
     *
     * @param matDialogRef
     * @param _data
     * @param translationLoader
     * @param translate
     * @param _matDialog
     */
    constructor(
        public matDialogRef: MatDialogRef<AddParticipantDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private translationLoader: FuseTranslationLoaderService,
        translate: TranslateService,
        public _matDialog: MatDialog,
        private userService: UserService,
        private _formBuilder: FormBuilder,
    ) {
        this._unsubscribeAll = new Subject();
        this.translationLoader.loadTranslations(polish);

        this.userService.getAllCustomers().subscribe((res: Items)=>{
            this.customers = res.items;
            this.filteredOptions = this.form.get('customer').valueChanges
                .pipe(
                    startWith(''),
                    debounceTime(300),
                    switchMap(value => {
                        if (value !== '') {
                            return this.lookup(value);
                        } else {
                            return of(null);
                        }
                    })
                );
        }, error => {

        });

        this.form = this._formBuilder.group({
            customer: [],
        });
    }

    displayFn(userId: User): string {
        return (userId)? userId.firstName + ' ' + userId.lastName + '; ' + (userId.phone?userId.phone:''): '';
    }

    lookup(value: string): Observable<Items> {
        this.unsubscribe();
        return this.userService.getAllCustomersBy(value).pipe(
            takeUntil(this._unsubscribeAll),
            // map the item property of the github results as our return object
            map(results => results.items),
            // catch errors
            catchError(_ => {
                return of(null);
            })
        );
    }

    public unsubscribe(): void {
        this._unsubscribeAll.next();
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
